import styled from "styled-components";
import CelesteBan from '../../assets/img/celeste-banner.avif'
import { globalStyles } from "../../util/globalStyles";

export const CelesteShortcutWrapper = styled.div`
    height: 80px;
    width: 80px;
    border: 2px solid white;
    border-radius: 50%;
    position: fixed;
    bottom: 50px;
    right: 50px;
    z-index: 9;
    cursor: pointer;
    filter: drop-shadow(0 0 0.25rem crimson);
    background-image: url(${CelesteBan});
    background-size: cover;
    background-position: center;

    &:hover {
        filter: drop-shadow(0 0 0.75rem crimson);
    }

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        height: 60px;
        width: 60px;
        bottom: 25px;
        right: 25px;
    }
`